import * as modal from "./modal.js";
import { MODAL_CLOSE_SEC } from "./config.js";
import recipeView from "./views/recipeView.js";
import searchView from "./views/searchView.js";
import resultsView from "./views/resultsView.js";
import paginationView from "./views/paginationView.js";
import bookmarksView from "./views/bookmarksView.js";
import addRecipeView from "./views/addRecipeView.js";


import "core-js/stable";
import "regenerator-runtime/runtime";
import { async } from "regenerator-runtime/runtime";

// if(module.hot) {
//   module.hot.accept();
// }

const controlRecipes = async function(){
  try{
    const id = window.location.hash.slice(1);

    if(!id) return;
    recipeView.renderSpinner();

    // 0 update results view to mark selected search results
    resultsView.update(modal.getSearchResultsPage());
    
    // 1. Updating bookmarks view
    bookmarksView.update(modal.state.bookmarks);

    // 2. loading recipe
    await modal.loadRecipe(id);
    
    // 3. Rendering recipe
    recipeView.render(modal.state.recipe);
    
  }catch(err){
    console.error(err);
    recipeView.renderError();
  }    
};

const controlSearchResults = async function() {
       try{
         resultsView.renderSpinner();

         // 1. Get search query
        const query = searchView.getQuery();
        if(!query) return;

        // 2. Load search result
        await modal.loadSearchResults(query);

        // 3. Render results
        //  resultsView.render(modal.state.search.results) 
        resultsView.render(modal.getSearchResultsPage()) 

        // 4. Render initial pagination
        paginationView.render(modal.state.search);

      }catch(err){
         console.log(err);
       }
};

const controlPagination = function(goTopage) {
      // 1. Render New results
        resultsView.render(modal.getSearchResultsPage(goTopage)) 

      // 2. Render New pagination button
        paginationView.render(modal.state.search);
}

const controlServings = function(newServings) {
  // Update the resipe servings (in state)
  modal.updateServings(newServings);

  // Update the recipe view
  // recipeView.render(modal.state.recipe);
  recipeView.update(modal.state.recipe);
};

const controlAddBookmark = function() {
  // 1. Add/Reamove bookmark
  if(!modal.state.recipe.bookmarked) modal.addBookmark(modal.state.recipe);
  else modal.deleteBookMark(modal.state.recipe.id);

  // 2. Update recipe view
  recipeView.update(modal.state.recipe);
 
  // 3. Render bookmarks
  bookmarksView.render(modal.state.bookmarks);

};

const controlBookmarks = function() {
  bookmarksView.render(modal.state.bookmarks)
}

const controlAddRecipe = async function(newRecipe) {
  try{
    // Show loading spinner
    addRecipeView.renderSpinner();

    // Upload the new Recipe data
    await modal.uploadRecipe(newRecipe);
    console.log(modal.state.recipe);

    // Render recipe
    recipeView.render(modal.state.recipe);

    // Success message
    addRecipeView.renderMessage();

    // Render bookmark view
    bookmarksView.render(modal.state.bookmarks);

    // Change ID in URL
    window.history.pushState(null, "", `#${modal.state.recipe.id}`);

    // Close form window
    setTimeout(function() {
      addRecipeView.toggleWindow()
  }, MODAL_CLOSE_SEC * 1000 )

  }catch(err){
    console.error("infjsfjejvn" , err)
    addRecipeView.renderError(err.message);
  }
};

const init = function(){
  bookmarksView.addHandlerRender(controlBookmarks);
    recipeView.addhandlerRender(controlRecipes);
    recipeView.addHandlerUpdateServings(controlServings);
    recipeView.addHandlerAddBookmark(controlAddBookmark);
    searchView.addHandlerSearch(controlSearchResults);
    paginationView.addHandlerClick(controlPagination);
    addRecipeView.addHandlerUpload(controlAddRecipe);
  };

init();
